__turbopack_context__.v({
  "sourcePortalsIcon": "uz9tuq_sourcePortalsIcon",
  "sourcePortalsWrapper": "uz9tuq_sourcePortalsWrapper",
});
